/**
 * silenceAndPauseResolver.js — FASE R6.
 *
 * Decides whether to engage understatement mode:
 * say less, stop earlier, leave reflective space.
 *
 * Especially important in:
 *   - grief
 *   - exhaustion
 *   - disappointment
 *   - unresolved pain
 *   - quiet discouragement
 *   - deep conversations (length ≥ 6 messages)
 *
 * Output silenceHint is ≤45 chars.
 */

const HEAVY_EXHAUSTION = new Set([
  "agotamiento_espiritual",
  "saturación_crítica",
  "agotamiento_crónico",
  "fatiga_moderada",
]);

/**
 * @param {{
 *   emotion:             string,
 *   processState:        string|null,
 *   conversationLength:  number,
 *   exhaustionState:     string,
 * }} params
 * @returns {{
 *   understateMode: boolean,
 *   maxSentences:   number|null,
 *   silenceHint:    string|null,
 * }}
 */
export function resolveUnderstatement({ emotion = "neutral", processState = null, conversationLength = 0, exhaustionState = "estable" }) {
  const isGrief    = emotion === "grief" || processState === "quebranto";
  const isExhaust  = HEAVY_EXHAUSTION.has(exhaustionState);
  const isDeep     = conversationLength >= 6;

  // Grief deep in conversation — most restraint
  if (isGrief && isDeep) {
    return { understateMode: true, maxSentences: 3, silenceHint: "Sin cierre completo. Deja espacio." };
  }

  // Grief early/mid
  if (isGrief) {
    return { understateMode: true, maxSentences: 4, silenceHint: "Termina antes de explicar todo." };
  }

  // Exhaustion deep in conversation
  if (isExhaust && isDeep) {
    return { understateMode: true, maxSentences: 3, silenceHint: "Corto y presente. Sin prescripciones." };
  }

  // Exhaustion early/mid
  if (isExhaust) {
    return { understateMode: true, maxSentences: 5, silenceHint: "No sobre-elabores." };
  }

  return { understateMode: false, maxSentences: null, silenceHint: null };
}
